import * as React from "react";
import { HandCoins, Shirt, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const helpOptions = [{
  title: "Al Pastor Prime",
  description: "Slow-roasted marinated pork, fresh pineapple, cilantro, and white onions on a handmade corn tortilla.",
  icon: Shirt,
  ctaText: "Order Now",
  ctaLink: "/FullMenuPage",
  badge: "$4.50"
}, {
  title: "The Street OG",
  description: "Classic carne asada with charred scallions, radish, and our signature habanero salsa verde.",
  icon: Users,
  ctaText: "Order Now",
  ctaLink: "/FullMenuPage",
  badge: "$4.00"
}, {
  title: "Baja Blast Taco",
  description: "Crispy beer-battered fish topped with chipotle slaw, pickled red onions, and lime crema.",
  icon: HandCoins,
  ctaText: "Order Now",
  ctaLink: "/FullMenuPage",
  badge: "Chef's Pick"
}];
export default function TheTacoLineup() {
  return <section data-section-id="223880" id="the-taco-lineup" className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-4xl font-default font-bold tracking-tighter text-foreground sm:text-6xl uppercase">
            The Taco Lineup
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground font-sans tracking-wide">
            Street-style soul with a premium pulse. Hand-pressed tortillas, fire-roasted meats, and the boldest flavors on wheels.
          </p>
        </div>

        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
          {helpOptions.map((option, i) => {
          const Icon = option.icon;
          return <Card key={option.title} data-index={i} className="flex flex-col h-full border-2 border-primary/20 bg-card shadow-md hover:border-primary hover:shadow-3xl transition-all duration-300 group">
                <CardHeader className="pb-4">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 text-primary">
                      <Icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    {option.badge && <Badge variant="default" className="font-default uppercase tracking-widest text-[12px] bg-primary text-primary-foreground rounded-md px-3 py-1">
                        {option.badge}
                      </Badge>}
                  </div>
                  <CardTitle className="text-3xl font-default text-foreground uppercase tracking-tight">
                    {option.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-sm font-sans text-muted-foreground leading-relaxed">
                    {option.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-6">
                  <Button asChild variant="secondary" size="lg" className="w-full font-default text-xl h-14 bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors rounded-md">
                    <Link to={option.ctaLink}>{option.ctaText}</Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}